import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import React from 'react';
import { Card, Spinner, Table } from 'react-bootstrap';
import SessionByUsesChart from './SessionByUsesChart';
import TableRow from './TableRow';

const SessionByUses = ({
  title,
  data,
  labelPrefix,
  xAxisLabel = 'Category',
  yAxisLabel = 'Value'
}) => {
  return (
    <Card className="h-100" style={{ minHeight: '32rem' }}>
      <FalconCardHeader title={title} titleTag="h6" className="py-2" light />
      <Card.Body
        as={Flex}
        direction="column"
        justifyContent="between"
        className="py-0"
      >
        {data ? (
          <div>
            <div className="my-auto py-3">
              <SessionByUsesChart
                data={data}
                labelPrefix={labelPrefix}
                xAxisLabel={xAxisLabel}
                yAxisLabel={yAxisLabel}
              />
            </div>
            <div className="border-top overflow-auto" style={{ height: 140 }}>
              <Table size="sm" className="mb-0">
                <tbody>
                  {data.map(item => (
                    <TableRow
                      key={item.label}
                      data={item}
                      labelPrefix={labelPrefix}
                    />
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        ) : (
          <div className="d-flex h-100 align-items-center justify-content-center">
            <Spinner variant="primary" />
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

SessionByUses.propTypes = {
  //data: PropTypes.arrayOf(PropTypes.shape(TableRow.propTypes.data)).isRequired
};

export default SessionByUses;
